export const DEFAULT_PAGE_TAKE = 50
export const DEFAULT_TAKE_OPTIONS = [10, 25, 50, 100]
